import { render, staticRenderFns } from "./Artists.vue?vue&type=template&id=4f019566&scoped=true&"
import script from "./Artists.vue?vue&type=script&lang=js&"
export * from "./Artists.vue?vue&type=script&lang=js&"
import style0 from "./Artists.vue?vue&type=style&index=0&id=4f019566&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f019566",
  null
  
)

export default component.exports